import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { ServicesBento } from "@/components/site/ServicesBento";
import { AboutSplit } from "@/components/site/AboutSplit";
import { WhyUs } from "@/components/site/WhyUs";
import { Testimonials } from "@/components/site/Testimonials";
import { ContactBlock } from "@/components/site/ContactBlock";

export default function Home() {
  return (
    <div data-testid="page-view-home">
      <Hero />
      <Marquee />
      <ServicesBento />
      <AboutSplit />
      <WhyUs />
      <Testimonials />
      <ContactBlock />
    </div>
  );
}
